/* asvendo elektro — Apple-level micro-interactions
   Lightweight, no dependencies. Scroll reveal + header glass.
   BULLETPROOF: content is never permanently hidden — multiple
   failsafes guarantee reveal even if IntersectionObserver misfires.
   Respects prefers-reduced-motion. */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Zoom auf dem iPhone zurueckgeben ----------------------------------
     layout/theme.liquid Zeile 6 setzt maximum-scale=5.0 — Vergroessern ist
     also ausdruecklich erlaubt. assets/theme.js Zeile 5851 ueberschreibt das
     Meta-Element auf jedem Geraet, dessen navigator.platform "iPhone", "iPad"
     oder "iPod" enthaelt, mit minimum-scale=1.0, maximum-scale=1.0. Auf genau
     den Geraeten, um die es bei der Handy-Ansicht geht, laesst sich die Seite
     danach nicht mehr aufziehen.

     Das ist kein Entwurf, sondern ein Nebeneffekt: die Sperre verhindert auf
     aelteren Fassungen das Hineinzoomen beim Antippen eines Eingabefeldes.
     Dagegen hilft aber die Schriftgroesse — 16 px im Feld — und die steht seit
     dem 24.08.2026 ohnehin ueberall.

     Diese Datei laedt nach theme.js (layout/theme.liquid: Zeile 257 Modul,
     Zeile 321 defer; beide laufen nach dem Parsen in Dokumentreihenfolge),
     der Wert von hier gilt also. Genommen wird nicht ein neuer Wert, sondern
     der aus dem Layout — die Seite bekommt zurueck, was dort schon steht.
     WCAG 1.4.4 verlangt mindestens 200 Prozent. */
  (function zoomZurueck() {
    var meta = document.head.querySelector('meta[name="viewport"]');
    if (!meta || meta.content.indexOf("maximum-scale=1") === -1) return;
    meta.content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=5.0";
  })();

  function revealAll() {
    document.querySelectorAll(".asv-reveal:not(.asv-in)").forEach(function (el) {
      el.classList.add("asv-in");
    });
  }

  /* ---- Auto-tag top-level sections for reveal (skip hero) ---- */
  function autoTag() {
    if (reduce) return;
    document.querySelectorAll("#main > .shopify-section").forEach(function (sec, i) {
      if (i === 0) return; // hero shows immediately
      sec.classList.add("asv-reveal");
    });
  }

  /* ---- Scroll reveal via IntersectionObserver + failsafes ---- */
  function initReveal() {
    var els = document.querySelectorAll(".asv-reveal");
    if (!els.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("asv-in");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -4% 0px", threshold: 0 }
    );

    els.forEach(function (el) {
      // anything already at/above viewport bottom: reveal now (no flash on load)
      var top = el.getBoundingClientRect().top;
      if (top < window.innerHeight * 0.95) {
        el.classList.add("asv-in");
      } else {
        io.observe(el);
      }
    });

    /* FAILSAFE 1: nothing stays hidden longer than 2s after load */
    setTimeout(revealAll, 2000);
    /* FAILSAFE 2: on full load, reveal anything still hidden shortly after */
    window.addEventListener("load", function () { setTimeout(revealAll, 600); });
    /* FAILSAFE 3: if tab is backgrounded during load, reveal on focus */
    window.addEventListener("pageshow", revealAll);
  }

  /* Hier hing ein Scroll-Zuhoerer, der ab 24 px die Klasse "is-scrolled" auf die
     Kopfzeile setzte. Der zugehoerige Effekt ist am 06.08.2026 entfallen (Ozan:
     "Soll kein Effekt sein beim Scrollen"), also faellt auch der Zuhoerer weg —
     ein Handler, der bei jedem Scrollschritt laeuft und nichts mehr bewirkt,
     kostet nur Rechenzeit auf dem Handy. */

  function init() {
    autoTag();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    autoTag();
    initReveal();
  });
})();
